import React, { useEffect, useState, Fragment, useCallback, useRef } from 'react'
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Button as ModalButton } from '@material-ui/core';
import { hideNavbar, logOut } from '../store/actions/CommonAction';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileData, updateLogo, updatePreferenceCenter, getPreferenceCenterThemeByClient, updateConsentGroup, getConsentGroupData, getconsentGroupDataByGroupId, getTemplateDetailByTemplateId, getTemplateDetailByConsentGroupId, getDashboard } from '../store/actions/CommonAction';
import logo from '../assets/JioSaavnLogoWhite.png'
import plusIcon from '../assets/plus.png'
import DropIcon from '@material-ui/icons/ExpandMore';
import PlusMaterialIcon from '@material-ui/icons/Add';
import preferenceCenter from '../style.css/preferenceCenter.css'
import accountcircle from '../assets/account_circle.svg'
//import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ConsentLoader from '../assets/loader.gif'
import CardEditIcon from '@material-ui/icons/LibraryBooks';
import PanelEditIcon from '@material-ui/icons/List';
import ButtonEditIcon from '@material-ui/icons/TouchApp';
import SwitchEditIcon from '@material-ui/icons/ToggleOn';
import helpicon from '../utils/helpicon';
import ColorIcon from '@material-ui/icons/FormatColorFill';
import PaddingIcon from '@material-ui/icons/AspectRatio';
import WidthIcon from '@material-ui/icons/Straighten';
import FontSizeIcon from '@material-ui/icons/FormatSize';
import FontColorIcon from '@material-ui/icons/FormatColorText';
import CustomizeIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import InfoIcon from '@material-ui/icons/InfoRounded';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { TimeoutLogic } from "../utils/TimeoutLogic";
import * as fs from 'fs';
import preferenceCenterFile from '../assets/preferenceCenterFile.txt'
// import DsrPopUp from '../assets/DsrPopUp'
import base64 from 'base-64';
// import { toast } from 'react-toastify';
import { ToastContainer, toast } from 'react-toastify';
import ReactQuill from 'react-quill';
//import JoditEditor from 'jodit-react';
import 'react-quill/dist/quill.snow.css';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Accordion from 'react-bootstrap/Accordion';
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import JioLogo from '../assets/jioLogo.png';
import react from '../assets/react.PNG';
import react2 from '../assets/react2.PNG';
import angular from '../assets/angular.PNG';
import angular2 from '../assets/angular2.PNG';

// Safe DOM helper: these elements only exist while this screen is mounted, so
// guard against null to avoid "Cannot read properties of null (reading 'style')"
// crashes when async callbacks finish after the component has unmounted.
const setElStyle = (id, prop, value) => {
  const el = document.getElementById(id);
  if (el) {
    el.style[prop] = value;
  }
};

var styleJson = {
  "card": {
    "backgroundColor": "",
    "color": ""
  },
  "panel": {
    "backgroundColor": "",
    "color": ""
  },
  "button": {
    "backgroundColor": "",
    "color": "",
  },
  "slider": {
    "backgroundColor": ""
  },
}

var consentTemplates = {
  "selfData": [],
  "shareData": []
}

var templateNameList = [];

var selectedConGroupData = [];

var descriptionText = "While using Jio Saavn, your activities create data that will be used by Jio Saavn to offer you better and more customized services. Jio Saavn uses this data in accordance with your permission (consent), details of which are clearly mentioned below. We do this, so that YOU are always aware of how we use your data, and YOU have total control on managing the usage of your data";
var clickingText = "By tapping/clicking the ‘Confirm Selection’ button below, you are giving your permission (consent) to Jio Saavn to use your data in accordance with the parameters mentioned above.";
var middleDescriptionText = "";
const CustomizePreferenceCenter = (props) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const [showToggleShare, setShowToggleShare] = useState(false);
  const [showToggleCardCustomize, setShowToggleCardCustomize] = useState(false);
  const [showTogglePanelCustomize, setShowTogglePanelCustomize] = useState(false);
  const [showToggleButtonCustomize, setShowToggleButtonCustomize] = useState(false);
  const [showToggleSwitchCustomize, setShowToggleSwitchCustomize] = useState(false);
  const [showToggleDescriptionCustomize, setShowToggleDescriptionCustomize] = useState(false);
  const [showToggleBottomDescriptionCustomize, setShowToggleBottomDescriptionCustomize] = useState(false);
  const [selectedConsentGroup, setSelectedConsentGroup] = useState('');
  const [showToggleConsentGroup, setShowToggleConsentGroup] = useState(false);
  const [showToggleTemplateCustomize, setShowToggleTemplateCustomize] = useState(false);
  const [showToggleSelfDrop, setShowToggleSelfDrop] = useState(false);
  const [showEmbedModal, setShowEmbedModal] = useState(false);

  const [status, setStatus] = useState(false)
  const [selectedStatusVal, setSelectedStatusVal] = useState('')
  //const [selectedConGroupData, setSelectedConGroupData] = useState([])

  const [fileContent, setFileContent] = useState('');
  const [modifiedContent, setModifiedContent] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [isPublishButtonDisabled, setIsPublishButtonDisabled] = useState(false);
  const [isUploadConsentNoticeButtonDisabled, setIsUploadConsentNoticeButtonDisabled] = useState(false);
  const getTemplateList = useSelector(state => state.common.getTemplateList)
  const perferenceCenterData = useSelector(state => state.common.perferenceCenterData)
  const consentGroups = useSelector(state => state.common.getConsentGroupData) || []; // Access consentGroups from Redux store
  // console.log("consentGroups-->", JSON.stringify(consentGroups));

  const headerText = selectedConsentGroup?.consentText?.header;
  // console.log("headerText-->", headerText);

  const consentGroupsDataByGroupId = useSelector(state => state.common.getConsentGroupDataByGroupId); // Access consentGroups from Redux store
  const getConsentGroupDetailsByGroupId = useSelector(state => state.common.getConsentGroupDetailsByGroupId); // Access consentGroups from Redux store
  //alert(`FRONT-END Response getConsentGroupDetailsByGroupId---------------------> ${JSON.stringify(getConsentGroupDetailsByGroupId)}`);
  //alert(`FRONT-END Response getConsentGroupDataByGroupId---------------------> ${JSON.stringify(consentGroupsDataByGroupId)}`);
  const getTemplateDetailDataByTemplateId = useSelector(state => state.common.getTemplateDetailDataByTemplateId); // Access consentGroups from Redux store
  const [description, setDescription] = useState('');
  const [middleDescription, setmiddleDescription] = useState('');
  const [bottomDescription, setBottomDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const publishInFlight = useRef(false);
  let templateBySelectedGroupData = useSelector(state => state.common.templateBySelectedGroupData)
  //alert("%%%%%%%%%%%%%%%%%%%  " + JSON.stringify(templateBySelectedGroupData));

  const [templateToBeShown, setTemplateToBeShown] = useState('');
  //alert("templateToBeShown " + JSON.stringify(templateToBeShown));

  const [selectedConsentGroupHeader, setSelectedConsentGroupHeader] = useState('');
  const [selectedConsentGroupFooter, setSelectedConsentGroupFooter] = useState('');


  const [file, setFile] = useState();
  const dispatch = useDispatch();
  //const businessName = "Jio Saavn";
  const appName = useSelector(state => state.common.App_Name)
  const Logo = useSelector(state => state.common.App_Logo)
  const clientId = useSelector(state => state.common.clientId)
  const clientEmail = useSelector(state => state.common.email)
  const getProductTheme = useSelector(state => state.common.getProductTheme)

  // Initialize an array of toggle states with false values
  const [toggleStates, setToggleStates] = useState([]);

  const avatarImage = (Logo == undefined || Logo == null) ?
    accountcircle : Logo;
  const clientSecret = useSelector(state => state.common.clientSecret)
  const clientMobile = useSelector(state => state.common.mobile)

  const consentGroupIdSelectedValue = "";

  const Consent_API_Specification_V1_5_PDF = process.env.REACT_APP_Consent_API_Specification_V1_5;
  const Consent_Redirect_Portal_Integration_PDF = process.env.REACT_APP_Consent_Redirect_Portal_Integration;
  const Integrate_using_SMS = process.env.REACT_APP_Integrate_using_SMS;


  const handleAdditionalAction = () => {
    setShowEmbedModal(true);
  };



  const callAPI = async () => {
    try {
      await dispatch(getProfileData(clientId))

    } catch (error) {
      console.error(error)
    }
  }

  const handleCreateNewClick = () => {
    history.push('/createConsentGroup/:page')
  };

  // Assuming each element in consentGroups has a 'status' property
  const selectedConsentGroupData = consentGroups.find(
    (element) => element.consentGroupName === selectedConsentGroup
  );

  // Derive loading state
  const isLoadingList = consentGroups.length === 0;

  const handleConsentGroupChange = (event) => {

    //alert("event : "+event.target.value);

    //console.log("consentGroups : " + JSON.stringify(consentGroups));

    const selectedStatus = consentGroups.find(
      (element) => element.consentGroupName === event.target.value
    )?.status;


    const selectedConsentGroupId = consentGroups.find(
      (element) => element.consentGroupName === event.target.value
    )?.consentGroupId;
    //alert("selectedConsentGroupId---->" + selectedConsentGroupId)
    //consentGroupIdSelectedValue = selectedConsentGroupId;
    setSelectedConsentGroup(event.target.value);


    const selectedGroupName = event.target.value;
    const selectedGroup = consentGroups.find(
      (element) => element.consentGroupName === selectedGroupName
    );

    const selectedConsentGroupHeader = selectedGroup?.consentText?.header;
    const selectedConsentGroupFooter = selectedGroup?.consentText?.footer;
    // Remove any HTML tags from the header
    // const plainTextHeader = selectedConsentGroupHeader.replace(/<\/?[^>]+(>|$)/g, "");
    // const plainTextFooter = selectedConsentGroupFooter.replace(/<\/?[^>]+(>|$)/g, "");

    if (selectedStatus === 'DRAFT') {
      setStatus(true);
      setIsUploadConsentNoticeButtonDisabled(true);
      setIsPublishButtonDisabled(false);

      setSelectedStatusVal('DRAFT');

      const selectedConsentGroupData = consentGroups.find(
        (element) => element.consentGroupName === event.target.value
      ).templates;

      //alert("selectedConsentGroupData : ====> " + JSON.stringify(selectedConsentGroupData));
      setTemplateToBeShown(selectedConsentGroupData);

      //alert("------DRAFT SELECTED------------>" + JSON.stringify(templateToBeShown));
      //setSelectedConGroupData(selectedConsentGroupData);

      //console.log("selectedConsentGroupData : ====> " + JSON.stringify(selectedConsentGroupData));
      // templateBySelectedGroupData = selectedConsentGroupData;
      //console.log("selectConGroupData : ====> " + JSON.stringify(selectedConGroupData));

      //console.log("------DRAFT SELECTED------------>" + JSON.stringify(selectedConsentGroupData));
    } else if (selectedStatus === 'PUBLISHED') {
      // alert('PUBLISHED') 
      setStatus(false)
      setSelectedStatusVal('PUBLISHED');
      setIsUploadConsentNoticeButtonDisabled(false);
      setIsPublishButtonDisabled(false);
      getDetailByConsentGroupId(selectedConsentGroupId);

      getPreferenceCenterDetails(selectedConsentGroupId);

      setTemplateToBeShown(selectedConsentGroupData);


    } else {
      // Handle other cases if needed
      setIsUploadConsentNoticeButtonDisabled(false);
      setIsPublishButtonDisabled(false);

      getPreferenceCenterDetails(selectedConsentGroupId);
    }




    //alert("selectedConsentGroup : "+selectedConsentGroupId);
    // Set the selectedConsentGroupHeader for PUBLISHED
    const headerFromGroup = selectedConsentGroupHeader || getDefaultHeaderText();
    const footerFromGroup = selectedConsentGroupFooter || getDefaultFooterText();
    setSelectedConsentGroupHeader(headerFromGroup);
    setSelectedConsentGroupFooter(footerFromGroup);
    if (selectedConsentGroupHeader) {
      setDescription(selectedConsentGroupHeader);
    } else if (selectedStatus === 'DRAFT') {
      setDescription(getDefaultHeaderText());
    }
    if (selectedConsentGroupFooter) {
      setBottomDescription(selectedConsentGroupFooter);
    } else if (selectedStatus === 'DRAFT') {
      setBottomDescription(getDefaultFooterText());
    }

  };



  // const isDraftStatus = selectedConsentGroupData?.status === 'DRAFT';
  // console.log(" val of isDraftStatus ",isDraftStatus)
  // const isPublishedStatus = selectedConsentGroupData?.status === 'PUBLISHED';
  // console.log(" val of isPublishedStatus ",isPublishedStatus)

  // const handleFileChange = (event) => {
  //     const file = event.target.files[0];
  //     if (file) {
  //         const fileName = file.name;
  //         const fileExtension = fileName.split('.').pop().toLowerCase();
  //         if (fileExtension === 'pdf') {
  //             setSelectedFile(file);
  //             setIsPublishButtonDisabled(true);
  //         } else {
  //             // Show an error message or provide feedback that only PDF files are allowed.
  //             alert('Please select a PDF file.');
  //         }
  //     } else {
  //         setSelectedFile(null);
  //         setIsPublishButtonDisabled(true);
  //     }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const fileName = file.name;
      const fileExtension = fileName.split('.').pop().toLowerCase();
      const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB

      if (file.size <= maxSizeInBytes) {
        if (fileExtension === 'pdf') {
          setSelectedFile(file);
          setIsPublishButtonDisabled(true);
        } else {
          // Show an error message or provide feedback that only PDF files are allowed.
          alert('Please select a PDF file.');
          setIsPublishButtonDisabled(false);
        }
      } else {
        // Show an error message or provide feedback that the file size exceeds the limit.
        //alert('File size exceeds the allowed limit (2 MB).');
        toast.error("File size exceeds the allowed limit (2 MB).");
        setIsPublishButtonDisabled(false);
      }
    } else {
      setSelectedFile(null);
      setIsPublishButtonDisabled(false);
    }
  };



  // const handlePreviewClick = () => {
  //     if (selectedFile) {
  //         // Create a data URL for the selected PDF file
  //         const reader = new FileReader();
  //         reader.readAsDataURL(selectedFile);
  //         reader.onloadend = () => {
  //             const pdfDataUrl = reader.result;

  //             // Open the PDF in a new window or tab by navigating to the data URL
  //             window.open(pdfDataUrl, '_blank');
  //         };
  //     }
  // };


  // Use useCallback to memoize the toggleMenuShare function
  const toggleMenuShare = useCallback(
    (index) => {
      const updatedToggleStates = [...toggleStates];
      updatedToggleStates[index] = !updatedToggleStates[index];
      setToggleStates(updatedToggleStates);
    },
    [toggleStates] // Make sure to include toggleStates in the dependency array
  );



  const toggleSelfDrop = () => {
    setShowToggleSelfDrop(!showToggleSelfDrop);
  }
  const toggleMenu = () => {
    setShowToggle(!showToggle);
  }
  // const toggleMenuShare = () => {
  //     setShowToggleShare(!showToggleShare);
  // }

  const toggleCardCustomize = () => {

    setShowToggleCardCustomize(!showToggleCardCustomize);
  }

  const togglePanelCustomize = () => {
    setShowTogglePanelCustomize(!showTogglePanelCustomize);
  }
  const closeEmbedModal = () => {
    setShowEmbedModal(!showEmbedModal);
    setIsPublishButtonDisabled(false);
    window.location.reload();

  }
  const toggleButtonCustomize = () => {
    setShowToggleButtonCustomize(!showToggleButtonCustomize);
  }

  const toggleSwitchCustomize = () => {
    setShowToggleSwitchCustomize(!showToggleSwitchCustomize);
  }
  const toggleDescriptionCustomize = () => {

    setShowToggleDescriptionCustomize(!showToggleDescriptionCustomize);
  }
  const toggleBottomDescriptionCustomize = () => {
    setShowToggleBottomDescriptionCustomize(!showToggleBottomDescriptionCustomize)
  }
  const toggleConsentGroup = () => {

    setShowToggleConsentGroup(!showToggleConsentGroup);
  }
  const toggleTemplateCustomize = () => {
    setShowToggleTemplateCustomize(!showToggleTemplateCustomize);
  }

  const blurStyle = {
    backgroundColor: selectedConsentGroupData?.status === 'PUBLISHED' ? 'rgba(0, 0, 0, 0.1)' : 'white', // Adjust the background color for the blur effect
    filter: selectedConsentGroupData?.status === 'PUBLISHED' ? 'blur(1px)' : 'none', // Apply blur effect when published
  };

  var changeDescription = (val) => {
    if (selectedConsentGroupData?.status !== 'PUBLISHED') {
      descriptionText = val;
      setDescription(val);

    } else {
      //console.log("Description is disabled because the consent group is published.");


    }
  };
  var changemiddleDescription = (val) => {
    middleDescriptionText = val;
    //document.getElementById("preferenceDescription").innerHTML = val;
    setmiddleDescription(val);
  };


  var changeBottomDescription = (val) => {
    if (selectedConsentGroupData?.status !== 'PUBLISHED') {
      clickingText = val;
      setBottomDescription(val);

    } else {
      //console.log("Description is disabled because the consent group is published.");

    }
  };


  const setTemplateData = (val) => {
    //alert("val :"+JSON.stringify(val));

    let selfData = {
      "name": val.nickName,
      "consumer": val.templateDetails.dataConsumer,
      "provider": val.templateDetails.dataProvider,
      "duration": val.templateDetails.consentValidity.value + " " + val.templateDetails.consentValidity.unit,
      "purpose": val.templateDetails.purpose.text
    }

    if (!templateNameList.includes(val.nickName)) {
      // alert("not there already")
      templateNameList.push(val.nickName);
      consentTemplates.selfData.push(selfData);
    } else {
      // alert("already there");
    }

    // alert("templateNameList : " + templateNameList);
    //alert("consentTemplates : " + JSON.stringify(consentTemplates));

  }

  var customizeNow = (div, style, value) => {

    //alert("in");


    styleJson[div][style] = value;


    updateTheme(styleJson);

  }

  const updateTheme = (styleJsonVal) => {

    // console.log("styleJsonVal### : " + JSON.stringify(styleJsonVal));

    //panel
    const panelHeadNew1 = document.querySelector("#panelHeadNew1 button");
    const panelHeadNew2 = document.querySelector("#panelHeadNew2 button");
    const panelHeadNew3 = document.querySelector("#panelHeadNew3 button");
    const panelHeadNew4 = document.querySelector("#panelHeadNew4 button");


    // alert("1"+panelHeadNew1);
    // alert("2"+panelHeadNew2);
    // alert("3"+panelHeadNew3);
    // alert("4"+panelHeadNew4);

    if (panelHeadNew1 == null && panelHeadNew2 == null && panelHeadNew3 == null && panelHeadNew4 == null) {
      toast.error("please select a consent group to proceed");
      setElStyle("consentLoader", "display", "none");
      setElStyle("appColor", "display", "block");
    } else {

      //alert("2");

      //card
      setElStyle("appColor", "backgroundColor", styleJsonVal.card.backgroundColor);
      //alert("3");
      //card text
      // alert("styleJsonVal.card.color  : "+styleJsonVal.card.color);
      setElStyle("topDescription", "color", styleJsonVal.card.color);
      const topDescriptionP = document.querySelector("#topDescription p");
      if (topDescriptionP) {
        topDescriptionP.style.color = styleJsonVal.card.color;
      }
      setElStyle("bottomDescription", "color", styleJsonVal.card.color);
      const bottomDescriptionP = document.querySelector("#bottomDescription p");
      if (bottomDescriptionP) {
        bottomDescriptionP.style.color = styleJsonVal.card.color;
      }

      //alert(panelHeadNew1+", "+panelHeadNew2+", "+panelHeadNew3+", "+panelHeadNew4)

      if (panelHeadNew1 != null) {
        panelHeadNew1.style.backgroundColor = styleJsonVal.panel.backgroundColor;
        panelHeadNew1.style.color = styleJsonVal.panel.color;
      }
      if (panelHeadNew2 != null) {
        panelHeadNew2.style.backgroundColor = styleJsonVal.panel.backgroundColor;
        panelHeadNew2.style.color = styleJsonVal.panel.color;
      }
      if (panelHeadNew3 != null) {
        // alert("panelHeadNew3")
        panelHeadNew3.style.backgroundColor = styleJsonVal.panel.backgroundColor;
        panelHeadNew3.style.color = styleJsonVal.panel.color;
      }
      if (panelHeadNew4 != null) {
        //alert("panelHeadNew4")
        panelHeadNew4.style.backgroundColor = styleJsonVal.panel.backgroundColor;
        panelHeadNew4.style.color = styleJsonVal.panel.color;
      }
      //button
      //alert("button")
      setElStyle("button", "backgroundColor", styleJsonVal.button.backgroundColor);
      setElStyle("button", "color", styleJsonVal.button.color);
      setElStyle("consentLoader", "display", "none");
      setElStyle("appColor", "display", "block");
      //alert("button")

    }

  }

  // const confirmCustomization = async () => {
  //     // Prevent multiple clicks
  //     if (isLoading) {
  //         return;
  //     }
  //     setIsLoading(true);

  //     if (selectedConsentGroupData?.status === 'DRAFT') {

  //       //alert("DRAFT");

  //         setStatus(true);


  //         if(consentGroups!==""){
  //             const consentGroupId = consentGroups.find(
  //                 (element) => element.consentGroupName === selectedConsentGroup
  //             )?.consentGroupId;

  //             const consentGroupName = consentGroups.find(
  //                 (element) => element.consentGroupName === selectedConsentGroup
  //             )?.consentGroupName;

  //             //await getconsentGroupIdData(consentGroupId);

  //             let templatesResponse = await getconsentGroupDataByGroupId(consentGroupId);


  //             //alert("templatesResponse in first ->"+JSON.stringify(templatesResponse));



  //         //const templates = [];
  //         //alert("consentGroupsDataByGroupId -----------> : "+JSON.stringify(templatesResponse));
  //         // templates = templatesResponse.templates;

  //         var consentNoticeArr = {}
  //         if (selectedFile) {
  //             // Convert the selected PDF file to a base64 string
  //             let base64String = '';
  //             const reader = new FileReader();
  //             reader.readAsDataURL(selectedFile);
  //             reader.onloadend = async () => {
  //                 base64String = reader.result.split(',')[1]; // Extract the base64 part
  //                 // Now, you can make a PUT request with the base64String
  //                 //alert('Base64 String: ' + base64String);

  //                 const currentDate = new Date();
  //                 const timestamp = `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`;

  //                 consentNoticeArr = {
  //                     "meta": {
  //                         "timestamp": timestamp
  //                     },
  //                     "data": base64String
  //                 };

  //                 //alert('consentNoticeArr:'+JSON.stringify(consentNoticeArr))
  //                 if (consentNoticeArr.data != '') {
  //                     await dispatch(updateConsentGroup(consentNoticeArr, consentGroupName, consentGroupId, templatesResponse[0].templates, description, middleDescription, bottomDescription));
  //                     //toast("Your Consent Group is Published");
  //                     toast.success("Your Consent Group is Published");
  //                     customizeTheme(consentGroupId, clientId);
  //                     setIsLoading(false);
  //                     //history.push('/home'); // Redirect to the home page
  //                 } else {
  //                     await toast.error("Something went wrong: Your Consent Group cannot be Published");
  //                 }
  //             }


  //             };

  //         };


  //     } else if (selectedConsentGroupData?.status === 'PUBLISHED') {

  //         //setStatus('false')
  //        // setSelectedStatusVal('PUBLISHED');
  //         if(consentGroups!==""){
  //         const consentGroupId = consentGroups.find(
  //             (element) => element.consentGroupName === selectedConsentGroup
  //         )?.consentGroupId;

  //         const consentGroupName = consentGroups.find(
  //             (element) => element.consentGroupName === selectedConsentGroup
  //         )?.consentGroupName;

  //         let templatesResponse = await getconsentGroupDataByGroupId(consentGroupId);
  //         // Initialize an empty array to store the templates

  //         //console.log("clientId ###################: " + templatesResponse.clientId);
  //         customizeTheme(consentGroupId, templatesResponse.clientId);
  //     }

  //     }

  // }

  const getDefaultHeaderText = () =>
    `While using ${appName}, your activities create data that will be used by ${appName} to offer you better and more customized services. ${appName} uses this data in accordance with your permission (consent), details of which are clearly mentioned below. We do this, so that YOU are always aware of how we use your data, and YOU have total control on managing the usage of your data.`;

  const getDefaultFooterText = () =>
    `By tapping/clicking the ‘Confirm Selection' button below, you are giving your permission (consent) to ${appName} to use your data in accordance with the parameters mentioned above.`;

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        try {
          const result = reader.result || '';
          const base64String = String(result).includes(',')
            ? String(result).split(',')[1]
            : String(result);
          resolve(base64String);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(reader.error || new Error('Failed to read file'));
      reader.readAsDataURL(file);
    });
  };

  const confirmCustomization = async () => {
    if (isLoading || publishInFlight.current) {
      return;
    }
    publishInFlight.current = true;
    setIsLoading(true);

    try {
      if (selectedConsentGroupData?.status === 'DRAFT') {
        setStatus(true);

        if (consentGroups !== "") {
          const consentGroupId = consentGroups.find(
            (element) => element.consentGroupName === selectedConsentGroup
          )?.consentGroupId;

          const consentGroupName = consentGroups.find(
            (element) => element.consentGroupName === selectedConsentGroup
          )?.consentGroupName;

          if (!selectedFile) {
            toast.error("Please upload a Consent Notice before publishing");
            return;
          }

          let templatesResponse = await getconsentGroupDataByGroupId(consentGroupId);
          const templates =
            templatesResponse?.[0]?.templates ||
            templatesResponse?.templates ||
            null;

          if (!templates) {
            toast.error("Unable to load templates for this Consent Group. Please try again.");
            return;
          }

          const base64String = await readFileAsBase64(selectedFile);
          if (!base64String) {
            toast.error("Something went wrong: Your Consent Group cannot be Published");
            return;
          }

          const currentDate = new Date();
          const timestamp = `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`;
          const consentNoticeArr = {
            meta: {
              timestamp: timestamp,
            },
            data: base64String,
          };

          const headerText = (description && description.replace(/<\/?[^>]+(>|$)/g, '').trim())
            ? description
            : getDefaultHeaderText();
          const footerText = (bottomDescription && bottomDescription.replace(/<\/?[^>]+(>|$)/g, '').trim())
            ? bottomDescription
            : getDefaultFooterText();

          const publishResult = await dispatch(updateConsentGroup(
            consentNoticeArr,
            consentGroupName,
            consentGroupId,
            templates,
            headerText,
            middleDescription,
            footerText
          ));

          if (!publishResult?.success) {
            return;
          }

          // Publish succeeded — mark PUBLISHED even if theme/dashboard steps fail
          setSelectedConsentGroupHeader(headerText);
          setSelectedConsentGroupFooter(footerText);
          setDescription(headerText);
          setBottomDescription(footerText);
          setStatus(false);
          setSelectedStatusVal('PUBLISHED');
          setIsUploadConsentNoticeButtonDisabled(false);
          setIsPublishButtonDisabled(false);

          try {
            await customizeTheme(consentGroupId, clientId, headerText, middleDescription, footerText);
          } catch (themeError) {
            toast.error("Consent Group published, but preference center theme could not be updated. Please try updating the theme again.");
          }

          await dispatch(getConsentGroupData(clientId));

          let dashboardResult = await dispatch(getDashboard());
          if (!dashboardResult?.success) {
            dashboardResult = await dispatch(getDashboard());
          }

          toast.success("Your Consent Group is Published");
        }
      } else if (selectedConsentGroupData?.status === 'PUBLISHED') {
        if (consentGroups !== "") {
          const consentGroupId = consentGroups.find(
            (element) => element.consentGroupName === selectedConsentGroup
          )?.consentGroupId;

          let templatesResponse = await getconsentGroupDataByGroupId(consentGroupId);
          await customizeTheme(
            consentGroupId,
            templatesResponse?.clientId || templatesResponse?.[0]?.clientId || clientId,
            description,
            middleDescription,
            bottomDescription
          );
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      publishInFlight.current = false;
      setIsLoading(false);
    }
  };


  const customizeTheme = async (consentGroupId, clientId, topDescription, middleDesc, bottomDesc) => {
    let existingData = await getPreferenceCenterThemeByClient(consentGroupId);
    if (existingData == null || existingData == undefined) {
      await dispatch(updatePreferenceCenter(
        JSON.stringify(styleJson),
        null,
        consentGroupId,
        clientId,
        topDescription,
        middleDesc,
        bottomDesc
      ));
    } else {
      await dispatch(updatePreferenceCenter(
        JSON.stringify(styleJson),
        existingData,
        consentGroupId,
        clientId,
        topDescription,
        middleDesc,
        bottomDesc
      ));
    }

    setShowEmbedModal(true);
  }

  const editPreferenceCenterFile = async () => {
    var fs = require('fs');
    fs.readFile(preferenceCenterFile, 'utf8', function (err, data) {

      var formatted = data.replace(/8208449648/g, '7387531101');

      fs.writeFile(preferenceCenterFile, formatted, 'utf8', function (err) {
        if (err) return console.log(err);
      });
    });

    // const fileRead = new FileReader(preferenceCenterFile);
    // const data = fileRead.readAsText(preferenceCenterFile);


  }

  // const getPreferenceCenterDetails = async (selectedConsentGroupId) => {

  //      //alert("selectedConsentGroupId :"+selectedConsentGroupId);

  //     if (selectedConsentGroupId != undefined) {

  //         setElStyle("consentLoader", "display", "block");
  //         setElStyle("appColor", "display", "none");

  //         try {
  //             if (selectedConsentGroupId) {
  //                 let responseStyle = await getPreferenceCenterThemeByClient(selectedConsentGroupId);
  //                 //const formatedData = await formatStr(responseStyle);
  //                 setElStyle("consentLoader", "display", "block");
  //                 setElStyle("appColor", "display", "none");
  //                 setTimeout(function() {

  //                     if (responseStyle != undefined) {


  //                         console.log("perferenceCenterData :" + responseStyle);
  //                         const formattedData = await formatStr(responseStyle);
  //                         alert('Clean String-->'+ JSON.stringify(formattedData));

  //                         // Parse the cleaned JSON string into a JavaScript object
  //                         var jsonObject = JSON.parse(formattedData);

  //                         //alert("jsonObject :" + JSON.stringify(jsonObject));
  //                         updateTheme(JSON.parse(formattedData));
  //                     } else {
  //                         setElStyle("consentLoader", "display", "none");
  //                         setElStyle("appColor", "display", "block");
  //                     }

  //                 }, 5000);

  //             }

  //         }
  //         catch (error) {
  //             console.log('error ' + error + JSON.stringify(error))
  //             setElStyle("consentLoader", "display", "none");
  //             setElStyle("appColor", "display", "block");
  //         }

  //     } else {
  //         toast.info("Please Select a Consent Group to Proceed!");
  //         setIsLoading(false);
  //     }

  // }

  const getPreferenceCenterDetails = async (selectedConsentGroupId) => {
    if (selectedConsentGroupId != undefined) {
      setElStyle("consentLoader", "display", "block");
      setElStyle("appColor", "display", "none");
      //alert("Before try-->" + selectedConsentGroupId);
      try {
        if (selectedConsentGroupId) {
          let responseStyle = await getPreferenceCenterThemeByClient(selectedConsentGroupId);
          //setElStyle("consentLoader", "display", "block");
          //setElStyle("appColor", "display", "none");
          //alert("responseStyle" +JSON.stringify(responseStyle));
          // Using an immediately invoked asynchronous function expression (IIFE)
          (async () => {
            try {
              if (responseStyle != undefined) {
                //perferenceCenterData = responseStyle;
                // alert("perferenceCenterData :" + responseStyle);

                const formattedData = await formatStr(responseStyle);

                // console.log('formatted Data String in log---------------------------------------->' + JSON.stringify(formattedData));

                //var jsonObject = JSON.parse(formattedData);

                //console.log("jsonObject :" + JSON.stringify(jsonObject));

                updateTheme(formattedData);

              } else {
                //alert("Else Alert");
                setElStyle("consentLoader", "display", "none");
                setElStyle("appColor", "display", "block");
              }
            } catch (error) {
              //console.log('error ' + error + JSON.stringify(error))
              setElStyle("consentLoader", "display", "none");
              setElStyle("appColor", "display", "block");
            }
          })();
        }
      } catch (error) {
        //console.log('error ' + error + JSON.stringify(error))
        setElStyle("consentLoader", "display", "none");
        setElStyle("appColor", "display", "block");
      }
    } else {
      //toast.info("Please Select a Consent Group to Proceed!");
      //setIsLoading(false);
    }
  };



  // const formatStr = async (responseStyle) => {
  //        const replacedString = responseStyle.replace(/\\/g, '').replace(/\"/g, '"');
  //        //const cleanedString = responseStyle.replace(/\\/g, '').replace(/\s+/g, ' ');
  //        console.log('replacedString-->' + replacedString);
  //     return replacedString;
  //   };

  const formatStr = async (responseStyle) => {
    //alert("responseStyle in formatStr->" + JSON.stringify(responseStyle));
    try {
      // Removing backslashes and extra spaces
      const cleanedString = responseStyle.replace(/\\/g, '').replace(/\s+/g, ' ');

      console.log("cleanedString-->" + cleanedString.length);

      if (cleanedString.length == 203) {
        const cleanedStringWithoutQuotes = cleanedString.slice(1, -1);
        console.log("cleanedStringWithoutQuotes->", cleanedStringWithoutQuotes);

        // // the cleaned string into a JSON object
        const formattedObject = JSON.parse(cleanedStringWithoutQuotes);

        // console.log('formattedObject -->', formattedObject);

        return formattedObject;
      } else if (cleanedString.length == 463) {
        //const cleanedStringWithoutQuotes = cleanedString.slice(0, -1);
        // console.log("cleanedStringWithoutQuotes->", cleanedStringWithoutQuotes);
        // // the cleaned string into a JSON object
        const formattedObject = JSON.parse(cleanedString);

        console.log('formattedObject -->', formattedObject);

        return formattedObject;
      } else {
        const cleanedStringWithoutQuotes = cleanedString.slice(1, -1);
        console.log("cleanedStringWithoutQuotes->", cleanedStringWithoutQuotes);

        const formattedObject = JSON.parse(cleanedStringWithoutQuotes);

        console.log('formattedObject -->', formattedObject);

        return formattedObject;
      }


    } catch (error) {
      console.error('Error formatting string:', error);
      return null;
    }
  };




  const getconsentGroupIdData = async (consentGroupId) => {
    //alert('in getconsentGroupIdData function: ' + consentGroupId);
    try {
      await dispatch(getconsentGroupDataByGroupId(consentGroupId))
    }
    catch (error) {
      //console.log('error in getconsentGroupDataByGroupId -----> ' + error + JSON.stringify(error))
    }

  }


  const getTemplateByTemplateId = async (tempid) => {
    // alert('in getTemplateByTemplateId function: ' + tempid);
    try {
      await dispatch(getTemplateDetailByTemplateId(tempid))
    }
    catch (error) {
      //console.log('error in getTemplateByTemplateId -----> ' + error + JSON.stringify(error))
    }

  }


  // const applyTheme = () => {
  //    // document.getElementById("menuBar").style.setProperty('background-color', getProductTheme.theme, 'important');

  //     const consentCard = document.getElementsByClassName("consent-card");
  //     for (let i = 0; i < consentCard.length; i++) {
  //         consentCard[i].style.setProperty('border-top', '4px solid ' + getProductTheme.theme, 'important')
  //     }

  //     const cardHeader = document.getElementsByClassName("card-header");
  //     for (let i = 0; i < cardHeader.length; i++) {
  //         cardHeader[i].style.setProperty('color', getProductTheme.theme, 'important')
  //     }


  //     const dashboardCard = document.getElementsByClassName("dashboard-card");
  //     for (let i = 0; i < dashboardCard.length; i++) {
  //         dashboardCard[i].style.setProperty('border-top', '4px solid ' + getProductTheme.theme, 'important')
  //     }

  //     const th = document.getElementsByTagName("th");
  //     for (let i = 0; i < th.length; i++) {
  //         th[i].style.setProperty('color', getProductTheme.theme, 'important')
  //     }

  // }



  const InfoIconWithDescription = ({ description }) => {
    const [showDescription, setShowDescription] = useState(false);

    return (
      <div
        onMouseEnter={() => setShowDescription(true)}
        onMouseLeave={() => setShowDescription(false)}
        style={{ display: 'inline-block', position: 'relative' }}
      >
        <InfoIcon style={{ fontSize: '15px', color: '#555' }} />
        {showDescription && (
          <div className="description-tooltip-preference">
            <span>{description}</span>
          </div>
        )}
      </div>
    );
  };


  const getDetailByConsentGroupId = async (selectedConsentGroupId) => {


    try {
      if (selectedConsentGroupId) {
        //alert('IN getDetailByConsentGroupId-->'+selectedConsentGroupId);
        await dispatch(getTemplateDetailByConsentGroupId(selectedConsentGroupId));
        //
      }
    } catch (error) {
      //console.log('error in init screen ' + error + JSON.stringify(error));
      //await setError(true);
      // Handle the error, e.g., display an error message
    }
  };



  useEffect(() => {

    if (!sessionStorage.getItem('sessionId')) {
      toast.error(`Your Session has Expired: Please login again`);
      window.location.href = '/login';
    }

    callAPI();
    getPreferenceCenterDetails();
    //applyTheme();

  }, []);

  useEffect(() => {
    if (!appName) {
      return;
    }
    // Populate editable defaults only when Quill fields are still empty
    if (!description || !String(description).replace(/<\/?[^>]+(>|$)/g, '').trim()) {
      setDescription(getDefaultHeaderText());
    }
    if (!bottomDescription || !String(bottomDescription).replace(/<\/?[^>]+(>|$)/g, '').trim()) {
      setBottomDescription(getDefaultFooterText());
    }
  }, [appName]);



  useEffect(() => {
    async function fetchData() {
      try {
        await dispatch(getConsentGroupData(clientId));
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, [dispatch, clientId]);

  const [checked, setChecked] = useState(false);

  const [values, setValues] = useState({
    select1: '1',
    select2: '1',
    select3: '1',
    select4: '1',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });

    setChecked(event.target.checked);
  };

  const [activeSection, setActiveSection] = useState('showTopDescription');

  const toggleSection = (section) => {
    setActiveSection(section === activeSection ? null : section);
  };

  // Generate an array of numbers from 1 to 72
  const numberOptions = Array.from({ length: 72 }, (_, index) => index + 1);

  const codeString = `const MyComponent = () => {
    //Call the function with parameters
    myFunction('hello', 'world');

    return (
        <div>
            //Your component JSX
        </div>
    );
};`;

  const codeString2 = `
  fetchParameters('VX1XL0VUQH',
  'dsrecfa25f8-fb6d-393a-9e76-524554bb8f5f',
  'bb9dd176-aaf1-4e25-9e95-57a92682a999',
  '99b2c6e4-1b70-4cd2-8599-e089b79a55cb');
  `;

  const codeString3 = `
  // my-component.omponent.ts
import { Component }  from '@angular/core';
import './path/to/myFile.js';

@Component({
    selector: 'app-my-component',
    templateUrl: './my-component.component.html',
    styleUrls: ['./my-component.component.css']
})

export class MyComponent {
  constructor() {
        /* Now you can use functions or variables
        from your JavaScript file here */
  }
}
  `;

  const codeString4 = `
import { Component } from '@angular/core';
import './path/to/myFile.js';

@Component({
  selector: 'app-my-component',
  templateUrl: './my-component.component.html',
  styleUrls: ['./my-component.component.css']
})
export class MyComponent {
  constructor() {
    // Call functions or use variables from your JavaScript file here
    myFunction('hello', 'world');
  }
}`;



  return (
    <>
      <section className='content-header'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-12'>
              <h1 className='page-title'>
                Customize Preference Center
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className='content h-100'>
        {
          <Modal show={showEmbedModal} size='lg' onHide={closeEmbedModal} backdrop="static" >

            <Modal.Header >
              <Modal.Title>
                <h6>Use any of the below methods to embed Preference Center in your code</h6>
              </Modal.Title>

            </Modal.Header>
            <Modal.Body>
              <Accordion defaultActiveKey="0" className='custom-accordion'>
                <Accordion.Item className='br20 mb-3'>
                  <Accordion.Header className='hbr20'>
                    Integrate using JavaScript
                  </Accordion.Header>
                  <Accordion.Body className='hbr20'>
                    <p>
                      Step 1. <a href={preferenceCenterFile} download='preferenceCenterFile.js'>Download</a> the script file <br></br>
                      Step 2. Add the script in your file using <br></br>
                    </p>
                    <p>For React JS applications</p>
                    <Accordion defaultActiveKey="0" className='custom-accordion'>
                      <Accordion.Item className='br20 mb-3'>
                        <Accordion.Header className='hbr20'>
                          React JS
                        </Accordion.Header>
                        <Accordion.Body className='hbr20'>
                          <p>
                            <ol>
                              <li style={{ listStyleType: "none" }}>
                                1. Place your JavaScript file: First, place dsrpopup .js file in the appropriate location within your React project. Typically, you'd want to put it inside the src directory, which is where your application's source code resides.
                              </li>
                              <li style={{ listStyleType: "none" }}>
                                2. Import and use the function in your React component: Import the function into your React component and call it with the desired parameters.
                              </li>
                              <div style={{ margin: '20px' }}>
                                <div style={{
                                  padding: '10px',
                                  borderRadius: '5px',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px solid #ddd'
                                }}>
                                  <pre style={{
                                    margin: 0,
                                    overflowX: 'auto',
                                    padding: '10px',
                                    fontFamily: 'monospace',
                                    fontSize: '14px'
                                  }}>
                                    <code>{codeString}</code>
                                  </pre>
                                </div>
                              </div>
                              <li style={{ listStyleType: "none" }}>
                                3. fetchParameters
                              </li>
                              <div style={{ margin: '20px' }}>
                                <div style={{
                                  padding: '10px',
                                  borderRadius: '5px',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px solid #ddd'
                                }}>
                                  <pre style={{
                                    margin: 0,
                                    overflowX: 'auto',
                                    padding: '10px',
                                    fontFamily: 'monospace',
                                    fontSize: '14px'
                                  }}>
                                    <code>{codeString2}</code>
                                  </pre>
                                </div>
                              </div>
                            </ol>
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <p>For Angular applications</p>
                    <Accordion defaultActiveKey="0" className='custom-accordion'>
                      <Accordion.Item className='br20 mb-3'>
                        <Accordion.Header className='hbr20'>
                          Angular
                        </Accordion.Header>
                        <Accordion.Body className='hbr20'>
                          <p>
                            <ol>
                              <li style={{ listStyleType: "none" }}>
                                1. Store your .js file in a location where your Angular project can access it. Typically, you'd place it in the assets directory or any directory within your project.
                              </li>
                              <li style={{ listStyleType: "none" }}>
                                2. In your Angular component or service where you want to use the functionality from the JavaScript file, you can use TypeScript's import statement to import the file.
                              </li>
                              <div style={{ margin: '20px' }}>
                                <div style={{
                                  padding: '10px',
                                  borderRadius: '5px',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px solid #ddd'
                                }}>
                                  <pre style={{
                                    margin: 0,
                                    overflowX: 'auto',
                                    padding: '10px',
                                    fontFamily: 'monospace',
                                    fontSize: '14px'
                                  }}>
                                    <code>{codeString3}</code>
                                  </pre>
                                </div>
                              </div>
                              <li style={{ listStyleType: "none" }}>
                                3. Use the functionality- Once imported, you can use the functions or variables from your JavaScript file within your Angular component or service.
                              </li>
                              <div style={{ margin: '20px' }}>
                                <div style={{
                                  padding: '10px',
                                  borderRadius: '5px',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px solid #ddd'
                                }}>
                                  <pre style={{
                                    margin: 0,
                                    overflowX: 'auto',
                                    padding: '10px',
                                    fontFamily: 'monospace',
                                    fontSize: '14px'
                                  }}>
                                    <code>{codeString4}</code>
                                  </pre>
                                </div>
                              </div>
                            </ol>
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion defaultActiveKey="0" className='custom-accordion'>
                <Accordion.Item className='br20 mb-3'>
                  <Accordion.Header className='hbr20'>
                    Integrate using API
                  </Accordion.Header>
                  <Accordion.Body className='hbr20'>
                    <p>
                      To integrate using API, kindly click on the document link below
                      <br></br>
                      <a href={Consent_API_Specification_V1_5_PDF}
                        download="Consent API Specification V1.5 1"
                        target="_blank" rel="noopener noreferrer">Download API doc!</a>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion defaultActiveKey="0" className='custom-accordion'>
                <Accordion.Item className='br20 mb-3'>
                  <Accordion.Header className='hbr20'>
                    Integrate using Redirect portal
                  </Accordion.Header>
                  <Accordion.Body className='hbr20'>
                    <p>
                      To integrate using Redirect portal, kindly click on the document link below
                      <br></br>
                      <a href={Consent_Redirect_Portal_Integration_PDF}
                        download="Consent Redirect Portal Integration"
                        target="_blank">Download API doc!</a>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion defaultActiveKey="0" className='custom-accordion'>
                <Accordion.Item className='br20 mb-3'>
                  <Accordion.Header className='hbr20'>
                    Integrate using SMS
                  </Accordion.Header>
                  <Accordion.Body className='hbr20'>
                    <p>
                      To integrate using SMS, kindly click on the document link below
                      <br></br>
                      <a href={Integrate_using_SMS} download="Consent API Specification V1.5 1" target="_blank">Download API doc!</a>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Modal.Body>
            <Modal.Footer>
              {/* <MaterialButton variant="contained" color="primary"  onClick={handleClose}>Close</MaterialButton> */}
              <button onClick={closeEmbedModal} className="btn btn-outline-secondary btn-sm " >Close</button>
            </Modal.Footer>
          </Modal>

        }
        <div className='container'>
          <div className='row'>
            <div className='col-md-5' style={{ padding: '3%' }}>
              <div className='card custom-cards'>
                <div className='card-body'>
                  <div className='meta-search-box mb-3'>
                    <h6 className='heading'>Choose Consent Group</h6>
                    <div className="panel-body customizePanelBody" >
                      {/* <span className="icon-area">{showToggleConsentGroup ? '▼' : '▲'}</span> */}
                      {/* <select value={selectedConsentGroup} className="form-select data-type-text" onChange={handleConsentGroupChange}>
                                <option value="" style={{ fontSize: "14px" }}>Select a Consent Group</option>
                                {consentGroups.map((element, key) => (
                                    <option key={key} value={element.consentGroupName} style={{ fontSize: "14px", }}>{element.consentGroupName} - {element.status}</option>
                                ))}
                            </select> */}
                      <select
                        value={selectedConsentGroup}
                        className="form-select data-type-text"
                        onChange={handleConsentGroupChange}
                      >
                        {isLoadingList ? (
                          <option value="" disabled>
                            Loading...
                          </option>
                        ) : (
                          <>
                            <option value="" style={{ fontSize: "14px" }}>
                              Select a Consent Group
                            </option>
                            {consentGroups.map((element, key) => (
                              <option
                                key={key}
                                value={element.consentGroupName}
                                style={{ fontSize: "14px" }}
                              >
                                {element.consentGroupName} - {element.status}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                      <div style={{ borderTop: '2px solid #ccc', fontSize: '14px', marginTop: '10px' }}>
                        <button className="btn btn-primary btn-theme" onClick={handleCreateNewClick} style={{ marginTop: '10px', width: '150px' }}>Create New</button>
                      </div>
                    </div>
                  </div>
                  <div className='meta-search-box mb-3'>
                    <h6 className='heading'>Customized content</h6>
                    {/* <div class="d-grid gap-3">
                      <button className="btn btn-customized" type="button" onClick={() => toggleSection('showTopDescription')}>
                        Show Top Description
                      </button>
                      <button className="btn btn-customized" type="button" onClick={() => toggleSection('showBottomDescription')}>
                        Show Bottom Description
                      </button>
                    </div> */}
                    <div class="d-grid gap-3">
                      <button className="btn btn-customized" type="button" onClick={toggleDescriptionCustomize}>Show Top Description</button>
                      <div class="panel-body customizePanelBody" style={showToggleDescriptionCustomize ? { display: "block" } : { display: 'none' }}>


                        <div style={{ width: '100%' }}>
                          <ReactQuill class="form-control" id="headerQuill" rows={'6'} placeholder='Enter the description'
                            onChange={changeDescription} value={description}
                            theme='snow'
                            readOnly={selectedConsentGroupData?.status === 'PUBLISHED'}
                            style={blurStyle} />
                        </div>


                      </div>
                      <button className="btn btn-customized" type="button" onClick={toggleBottomDescriptionCustomize}>Show Bottom Description</button>
                      <div class="panel-body customizePanelBody" style={showToggleBottomDescriptionCustomize ? { display: "block" } : { display: 'none' }}>

                        <div>
                          <ReactQuill class="form-control" id="bottomQuill" rows={'6'} placeholder='Enter the description'
                            onChange={changeBottomDescription} value={bottomDescription} theme='snow'
                            readOnly={selectedConsentGroupData?.status === 'PUBLISHED'}
                            style={blurStyle}

                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div  className='meta-search-box mb-3'>
                <h6 className='heading'>Customized content</h6>
             
                    <div class="d-grid gap-3">
                        <button className="btn btn-customized" type="button" onClick={toggleDescriptionCustomize}>Show Top Description</button>
                        <div class="panel-body customizePanelBody" style={showToggleDescriptionCustomize ? { display: "block" } : { display: 'none' }}>
                         
                               
                                <div>
                                        <ReactQuill class="form-control" id="headerQuill" rows={'6'} placeholder='Enter the description'
                                            onChange={changeDescription} value={description}
                                            theme='snow'
                                            readOnly={selectedConsentGroupData?.status === 'PUBLISHED'}
                                            style={blurStyle} />
                                </div>
 
                                   
                        </div>
                        <button className="btn btn-customized" type="button" onClick={toggleDescriptionCustomize}>Show Bottom Description</button>
                        <div class="panel-body customizePanelBody" style={showToggleDescriptionCustomize ? { display: "block" } : { display: 'none' }}>
                           
                                        <div>
                                        <ReactQuill class="form-control" id="bottomQuill" rows={'6'} placeholder='Enter the description'
                                            onChange={changeBottomDescription} value={bottomDescription} theme='snow'
                                            readOnly={selectedConsentGroupData?.status === 'PUBLISHED'}
                                            style={blurStyle}
 
                                        />
                                   </div>
                        </div>
                    </div>
 
                </div> */}

                  <div className='meta-search-box mb-3'>
                    <h6 className='heading'>Customized Theme</h6>
                    <Accordion defaultActiveKey="0" className='customized-theme-accordion'>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          Card
                        </Accordion.Header>
                        <Accordion.Body>
                          {/* <div class="d-grid">
                            <button class="btn btn-customized-link" type="button" onClick={() => toggleSection('showCardColor')}>Color</button>
                            <button class="btn btn-customized-link" type="button" onClick={() => toggleSection('showCardText')}>Text</button>
                          </div> */}
                          <table class="table">
                            <tr style={{ margin: '3px' }}>
                              <th style={{ width: '50%' }}><span class="icon-area-head"><ColorIcon /></span>Background Color</th>
                              <td><input type="color" class="form-control"
                                onChange={(event) => customizeNow('card', 'backgroundColor', event.target.value)}></input></td>
                            </tr>
                            <tr style={{ margin: '3px' }}>
                              <th style={{ width: '50%' }}><span class="icon-area-head"><ColorIcon /></span>Text Color</th>
                              <td><input type="color" class="form-control"
                                onChange={(event) => customizeNow('card', 'color', event.target.value)}></input></td>
                            </tr>

                          </table>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          Consent Preferences Panel
                        </Accordion.Header>
                        <Accordion.Body>
                          {/* <div class="d-grid">
                            <button class="btn btn-customized-link" type="button" onClick={() => toggleSection('showHeadingColor')}>Color</button>
                            <button class="btn btn-customized-link" type="button" onClick={() => toggleSection('showHeadingText')}>Text</button>
                          </div> */}
                          <table class="table">
                            <tr style={{ margin: '3px' }}>
                              <th style={{ width: '50%' }}><span class="icon-area-head"><ColorIcon /></span>Background Color</th>
                              <td><input type="color" class="form-control"
                                onChange={(event) => customizeNow('panel', 'backgroundColor', event.target.value)}></input></td>
                            </tr>

                            <tr style={{ margin: '3px' }}>
                              <th style={{ width: '50%' }}><span class="icon-area-head"><FontColorIcon /></span>Font Color</th>
                              <td><input type="color" class="form-control"
                                onChange={(event) => customizeNow('panel', 'color', event.target.value)}
                              ></input></td>
                            </tr>
                            {/* <tr style={{margin:'3px'}}>
                                    <th style={{ width: '50%' }}><span class="icon-area-head"><FontSizeIcon /></span>Font Size</th>
                                    <td><input type="number" class="form-control"
                                        onChange={(event) => customizeNow('panelHead1', 'fontSize', event.target.value + 'px')}
                                    ></input></td>
                                </tr> */}
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>
                          Button
                        </Accordion.Header>
                        <Accordion.Body>
                          {/* <div class="d-grid">
                            <button class="btn btn-customized-link" type="button" onClick={() => toggleSection('showButtonColor')}>Color</button>
                            <button class="btn btn-customized-link" type="button" onClick={() => toggleSection('showButtonText')}>Text</button>
                          </div> */}
                          <table class="table">
                            <tr style={{ margin: '3px' }}>
                              <th style={{ width: '50%' }}><span class="icon-area-head"><ColorIcon /></span>Background Color</th>
                              <td><input type="color" class="form-control"
                                onChange={(event) => customizeNow('button', 'backgroundColor', event.target.value)}
                              ></input></td>
                            </tr>
                            <tr style={{ margin: '3px' }}>
                              <th style={{ width: '50%' }}><span class="icon-area-head"><ColorIcon /></span>Font Color</th>
                              <td><input type="color" class="form-control"
                                onChange={(event) => customizeNow('button', 'color', event.target.value)}
                              ></input></td>
                            </tr>


                          </table>
                        </Accordion.Body>
                      </Accordion.Item>
                      {/* <Accordion.Item eventKey="3">
                        <Accordion.Header>
                          Switch
                        </Accordion.Header>
                        <Accordion.Body>
                          
                            <table class="table">
                                <tr style={{margin:'3px'}}>
                                    <th style={{ width: '50%' }}><span class="icon-area-head"><ColorIcon /></span>Background Color</th>
                                    <td><input type="color" class="form-control"
                                        onChange={(event) => customizeNow('slider', 'backgroundColor', event.target.value)}
                                    ></input>
                                    </td>
                                </tr>
                            </table>
                        </Accordion.Body>
                      </Accordion.Item> */}
                    </Accordion>
                    <div class="action" style={{ marginTop: '4%' }}>
                      <input
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="fileInput"
                        disabled={!isUploadConsentNoticeButtonDisabled}
                      />
                      <label htmlFor="fileInput" className="btn btn-theme"
                        style={!isUploadConsentNoticeButtonDisabled ? { backgroundColor: "#ccc", opacity: "0.3" } : { backgroundColor: "#0074d9", opacity: "1", color: "#fff" }}>
                        <CloudUpload /><span style={{ marginRight: '8px' }}> Upload Consent Notice</span>

                      </label>
                      {/* {selectedFile && (
                        <p>Selected PDF: {selectedFile.name}
                            <a href={selectedFile} target="_blank">View PDF</a>
                        </p>

                    )} */}
                      {selectedFile && (
                        <p>Selected PDF: {selectedFile.name}
                          <a
                            href={URL.createObjectURL(selectedFile)}
                            className="btn btn-primary btn-theme"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                          >
                            Preview Selected PDF
                          </a>
                        </p>
                      )}
                      {/* <button class="btn btn-primary btn-theme"><CloudUpload /> Upload Consent Notice</button> */}
                    </div>
                  </div>
                  <div class="d-grid mt-2 d-flex gap-2">
                    <button class="btn btn-primary" style={{ width: '48%' }} type="button" id='publish' onClick={(event) => confirmCustomization(event.target.value)} disabled={!isPublishButtonDisabled || isLoading}>{isLoading ? 'Publishing...' : 'Publish'}</button>
                    <button className="btn btn-primary" style={{ width: '49%' }} type="button" id="additionalAction" onClick={handleAdditionalAction}>Integration Steps</button>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-7 right-custom-box-popup'>
              <img src={ConsentLoader} id="consentLoader" className="img-responsive p-0" style={{ display: 'none', height: '60px', position: 'absolute', margin: '30%', marginLeft: '45%', zIndex: '999' }} />
              <div className='card custom-cards' id='appColor' style={{ boxShadow: '0px 0px 9px 0px #858585' }}>
                <div className='card-body'>
                  <div className='row'>

                    <div className={`col-md-12 ${activeSection === 'showCardColor' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select primary Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Secondary Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Main Text Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                          <div className='meta-search-box customized-box'>
                            <h6 className='heading pe-5'>Select Label Text Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-12 ${activeSection === 'showCardText' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Main Text font</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <div className='row'>
                              <div className='col-12 mb-3'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select2'
                                  value={values.select2}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Jio Type</MenuItem>
                                  <MenuItem value='2'>Arial</MenuItem>
                                  <MenuItem value='3'>Calibri Light</MenuItem>
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  variant='standard'
                                  name='select3'
                                  value={values.select3}
                                  onChange={handleChange}
                                  select
                                >
                                  {numberOptions.map((number) => (
                                    <MenuItem key={number} value={number.toString()}>
                                      {number}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select4'
                                  value={values.select4}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Normal</MenuItem>
                                  <MenuItem value='2'>Light</MenuItem>
                                  <MenuItem value='3'>Bold</MenuItem>
                                </TextField>
                              </div>
                            </div>
                          </div>
                          <div className='meta-search-box customized-box'>
                            <h6 className='heading pe-5'>Select label Text font</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <div className='row'>
                              <div className='col-12 mb-3'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select2'
                                  value={values.select2}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Jio Type</MenuItem>
                                  <MenuItem value='2'>Arial</MenuItem>
                                  <MenuItem value='3'>Calibri Light</MenuItem>
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  variant='standard'
                                  name='select3'
                                  value={values.select3}
                                  onChange={handleChange}
                                  select
                                >
                                  {numberOptions.map((number) => (
                                    <MenuItem key={number} value={number.toString()}>
                                      {number}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select4'
                                  value={values.select4}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Normal</MenuItem>
                                  <MenuItem value='2'>Light</MenuItem>
                                  <MenuItem value='3'>Bold</MenuItem>
                                </TextField>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-12 ${activeSection === 'showHeadingColor' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Heading Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-12 ${activeSection === 'showHeadingText' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Heading Text font</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <div className='row'>
                              <div className='col-12 mb-3'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select2'
                                  value={values.select2}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Jio Type</MenuItem>
                                  <MenuItem value='2'>Arial</MenuItem>
                                  <MenuItem value='3'>Calibri Light</MenuItem>
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  variant='standard'
                                  name='select3'
                                  value={values.select3}
                                  onChange={handleChange}
                                  select
                                >
                                  {numberOptions.map((number) => (
                                    <MenuItem key={number} value={number.toString()}>
                                      {number}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select4'
                                  value={values.select4}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Normal</MenuItem>
                                  <MenuItem value='2'>Light</MenuItem>
                                  <MenuItem value='3'>Bold</MenuItem>
                                </TextField>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-12 ${activeSection === 'showButtonColor' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Button Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-12 ${activeSection === 'showButtonText' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Button Text font</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <div className='row'>
                              <div className='col-12 mb-3'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select2'
                                  value={values.select2}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Jio Type</MenuItem>
                                  <MenuItem value='2'>Arial</MenuItem>
                                  <MenuItem value='3'>Calibri Light</MenuItem>
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  variant='standard'
                                  name='select3'
                                  value={values.select3}
                                  onChange={handleChange}
                                  select
                                >
                                  {numberOptions.map((number) => (
                                    <MenuItem key={number} value={number.toString()}>
                                      {number}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                              <div className='col-6'>
                                <TextField
                                  fullWidth
                                  size='small'
                                  defaultValue='1'
                                  // label='Select Consent Group'
                                  variant='standard'
                                  name='select4'
                                  value={values.select4}
                                  onChange={handleChange}
                                  select
                                >
                                  <MenuItem value='1'>Normal</MenuItem>
                                  <MenuItem value='2'>Light</MenuItem>
                                  <MenuItem value='3'>Bold</MenuItem>
                                </TextField>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-12 ${activeSection === 'showSwitchColor' ? '' : 'd-none'}`}>
                      <div class="status-scroll">
                        <div class="d-flex">
                          <div className='meta-search-box customized-box me-3'>
                            <h6 className='heading pe-5'>Select Switch Color</h6>
                            <IconButton className='refresh' aria-label="refresh" size="small">
                              <AutorenewIcon fontSize="inherit" />
                            </IconButton>
                            <FormControl fullWidth variant="standard">
                              {/* <InputLabel>Search Select Taxonomy</InputLabel> */}
                              <Input
                                value='#98aff1'
                                type='text'
                                size='small'
                                endAdornment={
                                  <InputAdornment position="end">
                                    <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                      {/* <Search /> */}
                                    </button>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <div className='grid gap-2 d-flex mt-3'>
                              <button type='button' className='btn btn-color' style={{ background: '#98aff1' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#607fe3' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#0e38bc' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#09257a' }}>
                                {/* <Search /> */}
                              </button>
                              <button type='button' className='btn btn-color' style={{ background: '#06184d' }}>
                                {/* <Search /> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className='col-md-12 text-end mt-3'>
                      <button type="button" className='btn btn-primary btn-r25 px-3'>Save</button>
                    </div> */}
                  </div>
                  <div className='row mt-4'>
                    <div className='col-md-12'>
                      <div className='pop-logo mb-2' style={{ display: 'flex' }}>
                        <img src={Logo} id="jioLogo" alt="Logo" style={{ height: '40px', marginBottom: '10px' }} />
                        <h3 className='pop-title' style={{ fontFamily: 'JioType', fontSize: '25px', marginLeft: '5px', marginTop: '4px' }}>{appName}</h3>
                      </div>

                    </div>
                  </div>


                  <div className='row'>
                    {/* <div className='col-md-12 my-4'>
                      <div className="card custom-cards dark no-shadow">
                        <div className='card-body'>
                        </div>
                      </div>
                    </div> */}

                    <div className='row' style={{ marginBottom: '3%' }}>
                      <div className='col-md-12' id='topDescription' style={{ textAlign: 'justify' }}
                      >
                        {selectedStatusVal !== 'PUBLISHED' ? (
                          description ? (
                            <div dangerouslySetInnerHTML={{ __html: description }} />
                          ) : (
                          <p>
                            While using <strong>{appName}</strong>, your activities create data that will be used by <strong>{appName}</strong> to offer you better and more customized services. <strong>{appName}</strong> uses this data in accordance with your permission (consent), details of which are clearly mentioned below. We do this, so that <strong>YOU</strong> are always aware of how we use your data, and <strong>YOU</strong> have total control on managing the usage of your data.
                          </p>
                          )
                        ) : (
                          <div dangerouslySetInnerHTML={{ __html: selectedConsentGroupHeader || getDefaultHeaderText() }} />
                        )}
                      </div>
                    </div>

                    {selectedStatusVal == "DRAFT" &&
                      <div className='col-md-12'>
                        <Accordion defaultActiveKey="0" className='pop-custom-accordion'>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header id="panelHeadNew1">
                              Data used by {appName}
                            </Accordion.Header>
                            <Accordion.Body className='px-10'>
                              {templateToBeShown && templateToBeShown.map((item, key) => {
                                if (item.mandatory && !item.shared) {
                                  return (
                                    <div key={key} className='row align-items-center mb-0 mb-md-4'>
                                      <div className='col-6 mb-4'>
                                        <h3 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>
                                      <div className='col-6 mb-4 text-end'>
                                        <span className='status active'>Always Active</span>
                                      </div>
                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: "#F7F9FD", borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Used By</span>
                                                  {item.dataConsumer.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.consentTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.consentValidity.value} {item.consentValidity.unit}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                          <div style={{ padding: '20px', background: "#E3F0FD", borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              {/* <div className='col-md-6'>
                                            <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px',  lineHeight: '18px', borderRight:'2px solid #e1e1e1' }}>
                                              <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                              {item.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                            </h6>
                                          </div> */}
                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.dataTypes.join(', ')}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />
                                    </div>
                                  );
                                } else if (!item.mandatory && !item.shared) {
                                  return (
                                    <div key={key} className='row align-items-center mb-0 mb-md-4'>
                                      <div className='col-6 mb-4'>
                                        <h3 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>
                                      <div className='col-6 mb-4 text-end'>
                                        <Switch
                                          checked={checked}
                                          onChange={handleChange}
                                          sx={{
                                            '& .MuiSwitch-switchBase': {
                                              color: checked ? '#0f3cc9' : '#333',
                                            },
                                          }}
                                        />
                                      </div>
                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: "#F7F9FD", borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Used By</span>
                                                  {item.dataConsumer.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.consentTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.consentValidity.value} {item.consentValidity.unit}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                          <div style={{ padding: '20px', background: "#E3F0FD", borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              {/* <div className='col-md-6'>
                                            <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px',  lineHeight: '18px', borderRight:'2px solid #e1e1e1' }}>
                                              <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                              {item.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                            </h6>
                                          </div> */}
                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.dataTypes.join(', ')}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header id="panelHeadNew2">

                              Data Shared with other entities
                            </Accordion.Header>
                            <Accordion.Body className='px-10'>
                              {templateToBeShown && templateToBeShown.map((item, index) => {
                                if (!item.mandatory && item.shared) {
                                  return (
                                    <div className='row align-items-center mb-0 mb-md-4' key={index}>
                                      <div className='col-6' style={{ marginBottom: '0rem' }}>
                                        <h3 style={{ color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>
                                      <div className='col-6 mb-4 text-end'>
                                        <Switch
                                          checked={checked}
                                          onChange={handleChange}
                                          sx={{
                                            '& .MuiSwitch-switchBase': {
                                              color: checked ? '#0f3cc9' : '#333',
                                            },
                                          }}
                                        />
                                      </div>
                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: "#F7F9FD", borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared With</span>
                                                  {item.dataConsumer.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.consentTypes.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.consentValidity.value} {item.consentValidity.unit}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                          <div style={{ padding: '20px', background: "#E3F0FD", borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>


                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.dataTypes.join(', ')}
                                                </h6>
                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />
                                    </div>
                                  );
                                }
                                else if (item.mandatory && item.shared) {
                                  return (
                                    <div className='row align-items-center mb-0 mb-md-4' key={index}>
                                      <div className='col-6 mb-4'>
                                        <h3 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>


                                      <div className='col-6 mb-4 text-end'>
                                        <span className='status active'>Always Active</span>
                                      </div>

                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: '#F7F9FD', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared With</span>
                                                  {(item.dataConsumer || []).map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.dataConsumer.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.consentTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.consentValidity.value} {item.consentValidity.unit}
                                                </h6>
                                              </div>
                                              {/* <div className='col-md-3'>
                                          <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px',  lineHeight: '18px', borderRight:'2px solid #e1e1e1' }}>
                                            <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                            {item.purpose.map((ele, key) => (
                                              <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                            ))}
                                          </h6>
                                        </div> */}
                                            </div>
                                          </div>

                                          <div style={{ padding: '20px', background: '#E3F0FD', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.dataTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.dataTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>



                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />

                                    </div>

                                  );
                                }
                                return null;
                              })}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    }

                    {selectedStatusVal == "PUBLISHED" &&
                      <div className='col-md-12'>
                        <Accordion defaultActiveKey="0" className='pop-custom-accordion'>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header id="panelHeadNew3">
                              Data used by {appName}
                            </Accordion.Header>
                            <Accordion.Body className='px-10'>
                              {templateBySelectedGroupData && templateBySelectedGroupData.map((item, key) => {
                                if (item.templateDetails.mandatory && !item.templateDetails.shared) {
                                  return (
                                    <div key={key} className='row align-items-center mb-0 mb-md-4'>
                                      <div className='col-6 mb-4'>
                                        <h3 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>
                                      <div className='col-6 mb-4 text-end'>
                                        <span className='status active'>Always Active</span>
                                      </div>
                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: "#F7F9FD", borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Used By</span>
                                                  {item.templateDetails.dataConsumer.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.templateDetails.consentTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.templateDetails.consentValidity.value} {item.templateDetails.consentValidity.unit}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                          <div style={{ padding: '20px', background: "#E3F0FD", borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.templateDetails.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              {/* <div className='col-md-6'>
                                            <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px',  lineHeight: '18px', borderRight:'2px solid #e1e1e1' }}>
                                              <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                              {item.templateDetails.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                            </h6>
                                          </div> */}
                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.templateDetails.dataTypes.join(', ')}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />
                                    </div>
                                  );
                                } else if (!item.templateDetails.mandatory && !item.templateDetails.shared) {
                                  return (
                                    <div key={key} className='row align-items-center mb-0 mb-md-4'>
                                      <div className='col-6 mb-4'>
                                        <h3 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>
                                      <div className='col-6 mb-4 text-end'>
                                        <Switch
                                          checked={checked}
                                          onChange={handleChange}
                                          sx={{
                                            '& .MuiSwitch-switchBase': {
                                              color: checked ? '#0f3cc9' : '#333',
                                            },
                                          }}
                                        />
                                      </div>
                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: "#F7F9FD", borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Used By</span>
                                                  {item.templateDetails.dataConsumer.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.templateDetails.consentTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.templateDetails.consentValidity.value} {item.templateDetails.consentValidity.unit}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                          <div style={{ padding: '20px', background: "#E3F0FD", borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.templateDetails.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              {/* <div className='col-md-6'>
                                            <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px',  lineHeight: '18px', borderRight:'2px solid #e1e1e1' }}>
                                              <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                              {item.templateDetails.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                            </h6>
                                          </div> */}
                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.templateDetails.dataTypes.join(', ')}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header id="panelHeadNew4">
                              Data Shared with other entities
                            </Accordion.Header>
                            <Accordion.Body className='px-10'>
                              {templateBySelectedGroupData && templateBySelectedGroupData.map((item, index) => {
                                if (!item.templateDetails.mandatory && item.templateDetails.shared) {
                                  return (
                                    <div className='row align-items-center mb-0 mb-md-4' key={index}>
                                      <div className='col-6' style={{ marginBottom: '0rem' }}>
                                        <h3 style={{ color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>

                                      <div className='col-6 mb-4 text-end'>
                                        <Switch
                                          checked={checked}
                                          onChange={handleChange}
                                          sx={{
                                            '& .MuiSwitch-switchBase': {
                                              color: checked ? '#0f3cc9' : '#333',
                                            },
                                          }}
                                        />
                                      </div>
                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: "#F7F9FD", borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared With</span>
                                                  {item.templateDetails.dataConsumer.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.templateDetails.consentTypes.join(', ')}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.templateDetails.consentValidity.value} {item.templateDetails.consentValidity.unit}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                          <div style={{ padding: '20px', background: "#E3F0FD", borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.templateDetails.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>


                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.templateDetails.dataTypes.join(', ')}
                                                </h6>
                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />
                                    </div>
                                  );
                                }
                                else if (item.templateDetails.mandatory && item.templateDetails.shared) {
                                  return (
                                    <div className='row align-items-center mb-0 mb-md-4' key={index}>
                                      <div className='col-6 mb-4'>
                                        <h3 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>

                                          {item.nickName}
                                        </h3>
                                      </div>

                                      <div className='col-6 mb-4 text-end'>
                                        <span className='status active'>Always Active</span>
                                      </div>

                                      <div className='col-12'>
                                        <div className='pro-box' style={{ border: '1px solid #A6CDCD', borderRadius: '7px' }}>
                                          <div style={{ padding: '20px', background: '#F7F9FD', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared With</span>
                                                  {(item.templateDetails.dataConsumer || []).map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.dataConsumer.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Shared</span>
                                                  {item.templateDetails.consentTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-4'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Duration</span>
                                                  {item.templateDetails.consentValidity.value} {item.templateDetails.consentValidity.unit}
                                                </h6>
                                              </div>
                                              {/* <div className='col-md-3'>
                                          <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px',  lineHeight: '18px', borderRight:'2px solid #e1e1e1' }}>
                                            <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                            {item.templateDetails.purpose.map((ele, key) => (
                                              <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                            ))}
                                          </h6>
                                        </div> */}
                                            </div>
                                          </div>

                                          <div style={{ padding: '20px', background: '#E3F0FD', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px', borderBottom: '1px solid #ccc' }}>
                                            <div className='row'>
                                              <div className='col-md-7'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px', borderRight: '2px solid #e1e1e1' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Purpose</span>
                                                  {item.templateDetails.purpose.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>
                                              <div className='col-md-5'>
                                                <h6 style={{ margin: '0', color: '#000', fontFamily: 'JioType', fontSize: '14px', lineHeight: '18px' }}>
                                                  <span style={{ display: 'block', color: '#999', fontFamily: 'JioType', fontSize: '13px', fontWeight: '500', lineHeight: '18px' }}>Data Item</span>
                                                  {item.templateDetails.dataTypes.map((ele, key) => (
                                                    <React.Fragment key={key}>{ele}{key === item.templateDetails.dataTypes.length - 1 ? '' : ', '}</React.Fragment>
                                                  ))}
                                                </h6>
                                              </div>

                                            </div>
                                          </div>

                                          {/* <div style={{ padding: '20px', background: '#E3F0FD', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', borderBottom: 'none' }}>
                                  <div className='row'>
                                    
                                  </div>
                                </div> */}

                                        </div>
                                      </div>
                                      {/* Divider Line */}
                                      <hr style={{ margin: '12px', borderTop: '2px solid rgb(118 118 118)', width: '-webkit-fill-available' }} />

                                    </div>

                                  );
                                }
                                return null;
                              })}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    }





                  </div>

                  <div className='row mt-4'>
                    <div className='col-md-12' id="bottomDescription" style={{ textAlign: 'justify' }}
                    >
                      {selectedStatusVal !== 'PUBLISHED' ? (
                          bottomDescription ? (
                            <div dangerouslySetInnerHTML={{ __html: bottomDescription }} />
                          ) : (
                          <p>
                            By tapping/clicking the ‘Confirm Selection' button below, you are giving your permission (consent) to <strong>{appName}</strong> to use your data in accordance with the parameters mentioned above.
                          </p>
                          )
                        ) : (
                          <div dangerouslySetInnerHTML={{ __html: selectedConsentGroupFooter || getDefaultFooterText() }} />
                        )}
                      
                    </div>

                  </div>
                  <div className='row mt-4'>
                    <div className='col-md-12 text-center'>
                      <button
                        type="button"
                        className='btn'
                        id='button'
                        style={{ padding: '10px 15px', background: '#0A2885', color: '#FFF', fontSize: '14px', fontWeight: '700' }}
                      >Confirm Selection</button>
                    </div>
                  </div>
                  <div className='row align-items-center' style={{ marginTop: '4%' }}>
                    <div className='col-md-6'>
                      <p
                        style={{ margin: '0', color: '#999', fontSize: '12px', fontWeight: '500' }}
                      >Powered by <img src={JioLogo} id="jioLogo" alt="Logo" style={{ height: '20px' }} />&nbsp;<font style={{ color: '#000' }}>Consent Management Platform</font></p>
                    </div>
                    <div className='col-md-6 text-end'>
                      <ul className='pop-footer-link'>
                        <li style={{ listStyleType: 'none' }}>
                          {/* <a href="#!">Privacy Policy</a> */}
                          {selectedFile && (
                            <a href={URL.createObjectURL(selectedFile)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >Privacy Policy</a>)}
                        </li>
                        {/* <li style={{listStyleType: 'none'}}>
                          <a href="#!">Terms & Conditions</a>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )


}

export default CustomizePreferenceCenter;
